import Vue from "vue";
import store from "@/store";
import { Roles } from "@/interfaces/entities/User"; // Import Roles enum
import { DirectiveBinding } from "vue/types/options";

Vue.directive("role", {
    inserted(el: HTMLElement, binding: DirectiveBinding) {
        if (!binding.value) {
            return;
        }

        const requiredRoles: Roles[] = Array.isArray(binding.value) ? binding.value : [binding.value];

        // Check if the store has been initialized and has the getters
        if (!store || !store.getters || typeof store.getters.hasAnyRole !== "function") {
            console.warn("Vuex store or hasAnyRole getter not available. Cannot check roles for v-role directive.");
            return;
        }

        if (!store.getters.hasAnyRole(requiredRoles)) {
            console.warn("v-role directive removing element due to missing roles:", requiredRoles);
            el.parentNode?.removeChild(el);
        }
    }
});
